export default "/_next/static/eed73ae2d42f052225c9dcea8d9ff9cc.png";